import { ContributionType } from '../../../../../common/model/input/contributions/types';
import { CommerceType } from '../../../../../common/model/input/products/types';
import { PackedImpactScoresByIVV } from '../../../../../common/model/output/scores/types';
import { Valence } from '../../../../../common/model/types';

type SignupModalType = 'plain' | 'contribute' | 'limit';
export type ContributionSelectionType = 'company' | 'product';
type ModalType = SignupModalType | ContributionType | ContributionSelectionType;

const ALL_CONTRIBUTION_SELECTION_TYPES: ContributionSelectionType[] = ['company', 'product'];

export function isContributionSelectionType(type: ModalType): type is ContributionSelectionType {
  return ALL_CONTRIBUTION_SELECTION_TYPES.indexOf(type as ContributionSelectionType) > -1;
}

export interface ModalCompanyMetadatum {
  value: string;
  source: string;
  year?: number;
}

export interface ModalOptions {
  type?: ModalType;
  productScoreBreakDown?: {
    productCode: string;
    impactCode: string;
    valence: Valence;
  };
  target?: string; // for contributions
  targetName?: string; // for contributions
  contributionSubmitComplete?: boolean;
  signupSubmitCompleted?: boolean;
  disableClose?: boolean;
  // For contribution forms
  existingData?: {
    products?: Array<{ label: string; productCode: string }>;
    impacts?: PackedImpactScoresByIVV;
    revenue?: ModalCompanyMetadatum[];
    employees?: ModalCompanyMetadatum[];
    commerceType?: CommerceType;
    productDescription?: string;
  };
  confirmation?: {
    title: string;
    content: string | JSX.Element;
    confirmLabel: string;
    onConfirm: () => void;
    requestId: string;
  };
  investorOrCompany?: 'investor' | 'company';
}
